import { z } from 'zod';

// ─── 房源 schema ─────────────────────────────────────────────
// 改字段时改这里 + 后端 schema，TypeScript 会帮你找出所有要更新的地方
export const PropertyStatus = z.enum(['出售', '出租', '已售', '已租']);
export type PropertyStatus = z.infer<typeof PropertyStatus>;

export const PropertySchema = z.object({
	id: z.number(),
	room_number: z.string(),
	status: PropertyStatus,
	is_active: z.union([z.boolean(), z.literal(0), z.literal(1)]).transform((v) => Boolean(v)),
	community_name: z.string(),
	floor: z.string().nullable().optional(),
	area: z.number().nullable().optional(),
	decoration: z.string().nullable().optional(),
	garage: z.string().nullable().optional(),
	build_time: z.string().nullable().optional(),
	school_district: z.string().nullable().optional(),
	total_price: z.number().nullable().optional(),
	remarks: z.string().nullable().optional(),
	video_key: z.string().nullable().optional(),
	video_name: z.string().nullable().optional(),
	video_type: z.string().nullable().optional(),
	video_size: z.number().nullable().optional(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
});
export type Property = z.infer<typeof PropertySchema>;

// 后端只返回 properties + total，page / pageSize / totalPages 前端自己算
export const PropertiesResponseSchema = z.object({
	properties: z.array(PropertySchema),
	total: z.number(),
	page: z.number().optional(),
	pageSize: z.number().optional(),
	totalPages: z.number().optional(),
});
export type PropertiesResponse = z.infer<typeof PropertiesResponseSchema>;

// 列定义（给 column toggle 用）
export const COLUMN_DEFS = [
	{ key: 'room_number', label: '房号', defaultVisible: true },
	{ key: 'status', label: '状态', defaultVisible: true },
	{ key: 'is_active', label: '有效', defaultVisible: false },
	{ key: 'community_name', label: '小区', defaultVisible: true },
	{ key: 'floor', label: '楼层', defaultVisible: true },
	{ key: 'area', label: '面积', defaultVisible: true },
	{ key: 'decoration', label: '装潢', defaultVisible: true },
	{ key: 'garage', label: '车库', defaultVisible: false },
	{ key: 'build_time', label: '建造', defaultVisible: false },
	{ key: 'school_district', label: '学区', defaultVisible: true },
	{ key: 'total_price', label: '价格', defaultVisible: true },
	{ key: 'video_key', label: '视频', defaultVisible: false },
	{ key: 'remarks', label: '备注', defaultVisible: false },
	{ key: 'updated_at', label: '更新', defaultVisible: true },
] as const;
export type ColumnKey = (typeof COLUMN_DEFS)[number]['key'];
